import { SalesOrderItemType } from '../constants/sales-order-item-type.js';
/**
 * Line types that represent an order-level charge or credit rather than a stocked product --
 * Shipping and Tax (flat dollar amounts) and Discount (flat or percentage, stored as a negative
 * amount). These lines have no productId, are outside the Sample/Sale-Promo mixing rule (see
 * line-family.ts), and skip inventory reservation entirely.
 */
export const ADJUSTMENT_LINE_TYPES = new Set([
    SalesOrderItemType.DISCOUNT,
    SalesOrderItemType.SHIPPING,
    SalesOrderItemType.TAX,
]);
export function isAdjustmentLineType(typeId) {
    return ADJUSTMENT_LINE_TYPES.has(typeId);
}
export const ADJUSTMENT_LINE_LABEL = {
    [SalesOrderItemType.DISCOUNT]: 'Discount',
    [SalesOrderItemType.SHIPPING]: 'Shipping',
    [SalesOrderItemType.TAX]: 'Tax',
};
//# sourceMappingURL=adjustment-line-types.js.map